/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import Cookies from 'js-cookie'
import { api } from '.'
import { useAuthStore } from '@/store/auth'
import dayjs from 'dayjs'
import type { IAccount } from '@/types/Account'
import type { IUser } from '@/types/User'
import type { RecordId } from '@/types'
import type { IRepairOrder } from '@/types/RepairOrder'
import { ServerResponse, type PaginationMeta, type ResponseData } from '@/types/ServerResponse'
import type { OptionProps } from 'ant-design-vue/lib/select'
import type { ITicket, OperationType, ISchemaTemplate } from '@/types/Ticket'
import type { IComment } from '@/types/Comment'
import { XMLParser } from 'fast-xml-parser'
import downloadjs from 'downloadjs'
import type { INotification } from '@/types/Notification'
import { message } from 'ant-design-vue'
import type { Actions, IPurchasingRequest } from '@/types/PurchasingRequest'
import type { IApprovalRequest } from '@/types/ApprovalRequest'

export interface LoginUser {
  mobile: string
  /** @format password */
  password: string
}

export interface UpdateUser {
  email?: string
  password?: string
  username?: string
  bio?: string
  image?: string
}

export interface Profile {
  username: string
  bio: string
  image: string
  following: boolean
}

export interface Article {
  slug: string
  title: string
  description: string
  body: string
  tagList: string[]
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  favorited: boolean
  favoritesCount: number
  author: Profile
}

export interface NewArticle {
  title: string
  description: string
  body: string
  tagList?: string[]
}

export interface UpdateArticle {
  title?: string
  description?: string
  body?: string
}

export interface Comment {
  id: number
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt: string
  body: string
  author: Profile
}

export interface NewComment {
  body: string
}

export interface GenericErrorModel {
  status: number
  statusText: string
  error: {
    message: string
  }
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export const parseQuery = (args = {}) => {
  const query = {...args}
  if (query.sorter?.columnKey || query.sorter?.field) {
    let direction = query.sorter.order === 'descend' ? '-' : ''
    const field = query.sorter?.columnKey || query.sorter?.field
    query.sort = `${direction}${field}`
    delete query.sorter
  }

  if (query.filters !== undefined) {
    for (const key in query.filters) {
      if (Object.prototype.hasOwnProperty.call(query.filters, key)) {
        let value = query.filters[key]

        if (value !== null) {
          console.log('filterValue', value)
          if (Array.isArray(value)) {
            value.forEach((element, index) => {
              query[`filter[${key}][${index}]`] = element
            })
          } else {
            query[`filter[${key}]`] = value
          }
        }
      }
    }

    delete query.filters
  }

  return query
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'include',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(key => 'undefined' !== typeof query[key])
    return keys
      .map(key =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<ServerResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    if (['POST', 'PATCH', 'PUT', 'DELETE'].includes((requestParams.method || '').toUpperCase())) {
      let csrfToken = Cookies.get('XSRF-TOKEN')

      if (csrfToken === undefined) {
        await api.misc.csrf()
        csrfToken = Cookies.get('XSRF-TOKEN')
      }

      if (csrfToken) {
        requestParams.headers = {
          ...requestParams.headers,
          'X-XSRF-TOKEN': csrfToken,
        }
      }
    }

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : type === ContentType.FormData
            ? {}
            : { 'Content-Type': ContentType.Json }),
        },
        signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
        body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
      },
    ).then(async response => {
      const r = response as HttpResponse<ResponseData<T>, E>
      r.data = null as unknown as ResponseData<T>
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then(data => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch(e => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) {
        let error = '未知错误'
        let mute = false
        
        if (r.status == 401) {
          const userStore = useAuthStore()
          userStore.updateUser(null)
        } else if (r.status == 400) {
          error = '出错了'
        } else if (r.status == 403) {
          error = '权限不足，请获取权限后重试。';
        } else if (r.status >= 500 && r.status <= 600) {
          error = '服务器出错，请稍后再试';
        } else if (r.status == 404) {
          error = '找不到该资源';
        } else if (r.status == 422) {
          error = '你输入的内容有误，请更正后再提交'
          mute = true
        }

        if (r.error.message) {
          error = `${error}，错误信息: ${r.error.message}`
        }

        if (mute === false) {
          message.error(error)
        }

        throw data
      }

      return new ServerResponse<T, E>(data)
    })
  }
}

/**
 * @title Conduit API
 * @version 1.0.0
 * @license MIT License (https://opensource.org/licenses/MIT)
 * @baseUrl /api
 * @contact RealWorld (https://realworld.io)
 *
 * Conduit API
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {

  dashboard = (params: RequestParams = {}) => {
    return this.request<{}, GenericErrorModel>({
      path: `/dashboard`,
      method: 'GET',
      ...params,
    })
  }

  statistics = (subject, index, query = {}, params: RequestParams = {}) => {
    return this.request<{}, GenericErrorModel>({
      path: `/statistics`,
      method: 'GET',
      query: {
        subject,
        index,
        query: JSON.stringify(parseQuery(query))
      },
      ...params,
    })
  }

  misc = {
    codeSuggestion: (model, params: RequestParams = {}) => {
      return this.request<{}, GenericErrorModel>({
        path: `/misc/code-suggestion/${model}`,
        method: 'GET',
        ...params,
      })
    },
    csrf: async (params: RequestParams = {}) => {
      return this.request<{}, GenericErrorModel>({
        path: '/sanctum/csrf-cookie',
        method: 'GET',
        ...params,
      })
    },

    companies: (params: RequestParams = {}) => {
      return this.request<OptionProps[], GenericErrorModel>({
        path: '/companies',
        method: 'GET',
        ...params,
      })
    },

    uploadToken: (params: RequestParams = {}) => {
      return this.request<OptionProps[], GenericErrorModel>({
        path: '/misc/upload-token',
        method: 'GET',
        ...params,
      })
    },

    upload: (endpoint: string, tokenParams, params: RequestParams = {}) => {
      return this.request<GenericErrorModel>({
        path: '',
        method: 'POST',
        type: ContentType.FormData,
        body: {
          name: tokenParams.fileName,
          key: `${tokenParams.directory}${tokenParams.fileName}`,
          policy: tokenParams.policy,
          OSSAccessKeyId: tokenParams.accesskeyid,
          success_action_status: 200,
          callback: tokenParams.callback,
          signature: tokenParams.signature,
          file: tokenParams.file,
        },
        ...params,
        baseUrl: '//' + endpoint,
        credentials: 'omit',
      })
      // .then(async response => {
      //   console.log(response)

      //   console.log('body', new XMLParser().parse(response.body))

      //   const res = new ServerResponse({
      //     ...response.response,
      //     // data: new window.DOMParser().parseFromString(response.body, "text/xml")
      //   })
      //   console.log('res', res)
      //   return res
      // })
    },
  }

  users = {
    oauth: {
      index: (
        query?: {
          /**
           * The numbers of items to return.
           * @min 1
           * @default 20
           */
          per_page?: number
  
          /**
           * @default 1
           */
          page?: number
  
          sorter?: any
          filters?: any
        }, params: RequestParams = {}) => {
        return this.request<{}, GenericErrorModel>({
          path: `/users/third-party-oauth`,
          method: 'GET',
          query: parseQuery(query),
          ...params,
        })
      },
      sync: (params: RequestParams = {}) => {
        return this.request<{}, GenericErrorModel>({
          path: '/wework/sync-user-list',
          method: 'GET',
          ...params
        })
      },
      bind: (oauthId: RecordId, userId: RecordId, params: RequestParams = {}) => {
        return this.request<{}, GenericErrorModel>({
          path: `/wework/bind`,
          method: 'POST',
          body: {
            oauth_id: oauthId,
            user_id: userId,
          },
          ...params,
        })
      },
      unbind: (oauthId: RecordId, params: RequestParams = {}) => {
        return this.request<{}, GenericErrorModel>({
          path: `/wework/${oauthId}/unbind`,
          method: 'POST',
          body: {
            oauth_type: 'wework',
          },
          ...params,
        })
      },
    },
    
    /**
     * @description Login for existing user
     *
     * @tags User and Authentication
     * @name Login
     * @summary Existing user login
     * @request POST:/users/login
     */
    login: (data: LoginUser, params: RequestParams = {}) => {
      return this.request<
        {
          user: IUser
        },
        GenericErrorModel
      >({
        path: `/login`,
        method: 'POST',
        body: data,
        ...params,
      })
    },
    logout: (params: RequestParams = {}) => {
      return this.request<{}, GenericErrorModel>({
        path: '/logout',
        method: 'POST',
        ...params,
      })
    },

    /**
     * @description Get most recent users globally. Use query parameters to filter results. Auth is required
     *
     * @tags Users
     * @name GetUsers
     * @summary Get users globally
     * @request GET:/users
     */
    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      console.log('aaa', parseQuery(query))
      return this.request<
        {
          data: IUser[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/users`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    all: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      console.log('aaa', parseQuery(query))
      return this.request<
        {
          data: IUser[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/users`,
        method: 'GET',
        query: {
          ...parseQuery(query),
          per_page: 9999
        },
        ...params,
      })
    },
    /**
     * @description Register a new user
     *
     * @tags User and Authentication
     * @name create
     * @request POST:/users
     */
    create: (user: IUser, params: RequestParams = {}) =>
      this.request<
        {
          user: IUser
        },
        GenericErrorModel
      >({
        path: `/users`,
        method: 'POST',
        body: user,
        ...params,
      }),

    /**
     * @description Register a new user
     *
     * @tags User and Authentication
     * @name update
     * @request POST:/users
     */
    update: (id: RecordId, user: IUser, params: RequestParams = {}) =>
      this.request<
        {
          user: IUser
        },
        GenericErrorModel
      >({
        path: `/users/${id}`,
        method: 'PATCH',
        body: user,
        ...params,
      }),

    doAction: (action: string, records: Number[] | String | Number, params: RequestParams = {}) => {
      return this.request<{}, GenericErrorModel>({
        path: '/users/actions',
        method: 'POST',
        body: {
          action,
          records,
        },
        ...params,
      })
    },

    resetPassword: (id: Number[] | Number | String, params: RequestParams = {}) => {
      return this.users.doAction('reset-password', id, params)
    },

    deactivate: (id: Number[] | Number | String, params: RequestParams = {}) => {
      return this.users.doAction('deactivate', id, params)
    },

    reactivate: (id: Number[] | Number | String, params: RequestParams = {}) => {
      return this.users.doAction('reactivate', id, params)
    },

    show: (id: RecordId, params: RequestParams = {}) => {
      return this.request<
        {
          data: IUser
        },
        GenericErrorModel
      >({
        path: `/users/${id}`,
        method: 'GET',
        ...params,
      })
    },
  }
  user = {
    /**
     * @description Gets the currently logged-in user
     *
     * @tags User and Authentication
     * @name GetCurrentUser
     * @summary Get current user
     * @request GET:/user
     * @secure
     */
    getCurrentUser: (params: RequestParams = {}) =>
      this.request<IUser, GenericErrorModel>({
        path: `/user`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Updated user information for current user
     *
     * @tags User and Authentication
     * @name UpdateCurrentUser
     * @summary Update current user
     * @request PUT:/user
     * @secure
     */
    updateCurrentUser: (user: UpdateUser, params: RequestParams = {}) =>
      this.request<IUser, GenericErrorModel>({
        path: `/user`,
        method: 'PATCH',
        body: user,
        secure: true,
        ...params,
      }),
  }
  salesLeads = {
    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      return this.request<
        {
          data: Object[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/sales-leads`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    update: (id: RecordId, salesLead: Object, params: RequestParams = {}) =>
      this.request<
        {
          salesLead: Object
        },
        GenericErrorModel
      >({
        path: `/sales-leads/${id}`,
        method: 'PATCH',
        body: salesLead,
        ...params,
      }),
      delete: (id: RecordId, params: RequestParams = {}) =>
        this.request<
          GenericErrorModel
        >({
          path: `/sales-leads/${id}`,
          method: 'DELETE',
          ...params,
        }),
  }
  accounts = {
    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      return this.request<
        {
          data: IAccount[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/accounts`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    show: (id: RecordId, params: RequestParams = {}) => {
      return this.request<
        {
          data: IAccount
        },
        GenericErrorModel
      >({
        path: `/accounts/${id}`,
        method: 'GET',
        ...params,
      })
    },
    update: (id: RecordId, account: IAccount, params: RequestParams = {}) =>
      this.request<
        {
          account: IAccount
        },
        GenericErrorModel
      >({
        path: `/accounts/${id}`,
        method: 'PATCH',
        body: account,
        ...params,
      }),
    create: (account: IAccount, params: RequestParams = {}) =>
      this.request<
        {
          account: IAccount
        },
        GenericErrorModel
      >({
        path: `/accounts`,
        method: 'POST',
        body: account,
        ...params,
      }),
  }
  notification = {
    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      return this.request<
        {
          data: INotification[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/notifications`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    doAction: (action: string, records: Number[] | String | Number, params: RequestParams = {}) => {
      return this.request<{}, GenericErrorModel>({
        path: '/notifications/actions',
        method: 'POST',
        body: {
          action,
          records,
        },
        ...params,
      })
    },
    show: (id: RecordId, params: RequestParams = {}) => {
      return this.request<
        {
          data: INotification
        },
        GenericErrorModel
      >({
        path: `/notifications/${id}`,
        method: 'GET',
        ...params,
      })
    },
    count: (params: RequestParams = {}) => {
      return this.request<
        {
          read: Number,
          unread: Number
        },
        GenericErrorModel
      >({
        path: `/notifications/count`,
        method: 'GET',
        ...params,
      })
    },
    update: (id: RecordId, account: INotification, params: RequestParams = {}) =>
      this.request<
        {
          account: INotification
        },
        GenericErrorModel
      >({
        path: `/notifications/${id}`,
        method: 'PATCH',
        body: account,
        ...params,
      }),
    create: (notice: INotification, params: RequestParams = {}) =>
      this.request<{}, GenericErrorModel>({
        path: `/notifications`,
        method: 'POST',
        body: notice,
        ...params,
      }),
  }
  roles = {
    index: (params: RequestParams = {}) => {
      return this.request<GenericErrorModel>({
        path: '/roles',
        method: 'GET',
        ...params,
      })
    },
  }
  equipment = {
    types: (params: RequestParams = {}) => {
      return this.request<OptionProps[], GenericErrorModel>({
        path: '/equipment/types',
        method: 'GET',
        ...params,
      })
    },

    checkSNState: (sn: string) => {
      return this.request<OptionProps[], GenericErrorModel>({
        path: `/equipment/${sn}/state`,
        method: 'GET',
      })
    },

    checkNumberOfRepair: (id: RecordId) => {
      return this.request<OptionProps[], GenericErrorModel>({
        path: `/equipment/${id}/number-of-repair`,
        method: 'GET',
      })
    },

    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      return this.request<
        {
          data: IAccount[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/equipment`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    show: (id: RecordId, params: RequestParams = {}) => {
      return this.request<
        {
          data: IAccount
        },
        GenericErrorModel
      >({
        path: `/equipment/${id}`,
        method: 'GET',
        ...params,
      })
    },
    update: (id: RecordId, account: IAccount, params: RequestParams = {}) =>
      this.request<
        {
          account: IAccount
        },
        GenericErrorModel
      >({
        path: `/equipment/${id}`,
        method: 'PATCH',
        type: ContentType.Json,
        body: account,
        ...params,
      }),
    create: (account: IAccount, params: RequestParams = {}) =>
      this.request<
        {
          account: IAccount
        },
        GenericErrorModel
      >({
        path: `/equipment`,
        method: 'POST',
        body: account,
        ...params,
      }),
  }
  purchasingRequests = {
    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      return this.request<
        {
          data: IPurchasingRequest[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/purchasing-requests`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    show: (id: RecordId, params: RequestParams = {}) => {
      return this.request<
        {
          data: IPurchasingRequest
        },
        GenericErrorModel
      >({
        path: `/purchasing-requests/${id}`,
        method: 'GET',
        ...params,
      })
    },
    update: (id: RecordId, record: IPurchasingRequest, params: RequestParams = {}) =>
      this.request<
        {
          record: IPurchasingRequest
        },
        GenericErrorModel
      >({
        path: `/purchasing-requests/${id}`,
        method: 'PATCH',
        type: ContentType.Json,
        body: record,
        ...params,
      }),
    create: (record: IPurchasingRequest, params: RequestParams = {}) =>
      this.request<
        {
          record: IPurchasingRequest
        },
        GenericErrorModel
      >({
        path: `/purchasing-requests`,
        method: 'POST',
        body: record,
        ...params,
      }),
      batchAction: (actionName: "request-export", parameters: {}, records: any = null, params: RequestParams = {}) => {
        return this.request<
          GenericErrorModel
        >({
          path: `/purchasing-requests/actions`,
          method: 'POST',
          body: {
            action: actionName, 
            parameters,
            records
          },
          ...params,
        })
      },
      actions: (id: RecordId, action: Actions, record: IPurchasingRequest, params: RequestParams = {}) =>
        this.request<
          {
            record: IPurchasingRequest
          },
          GenericErrorModel
        >({
          path: `/purchasing-requests/${id}/actions`,
          method: 'POST',
          body: {
            action,
            ...record
          },
          ...params,
        }),
  }
  approvalRequests = {
    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      return this.request<
        {
          data: IApprovalRequest[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/approval-requests`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    show: (id: RecordId, params: RequestParams = {}) => {
      return this.request<
        {
          data: IApprovalRequest
        },
        GenericErrorModel
      >({
        path: `/approval-requests/${id}`,
        method: 'GET',
        ...params,
      })
    },
      batchAction: (actionName: "request-export", parameters: {}, records: any = null, params: RequestParams = {}) => {
        return this.request<
          GenericErrorModel
        >({
          path: `/approval-requests/actions`,
          method: 'POST',
          body: {
            action: actionName, 
            parameters,
            records
          },
          ...params,
        })
      },
      actions: (id: RecordId, action: Actions, record: IApprovalRequest, params: RequestParams = {}) =>
        this.request<
          {
            record: IApprovalRequest
          },
          GenericErrorModel
        >({
          path: `/approval-requests/${id}/actions`,
          method: 'POST',
          body: {
            action,
            ...record
          },
          ...params,
        }),
  }
  tickets = {
    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      return this.request<
        {
          data: ITicket[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/ticket/tickets`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    show: (id: RecordId, query, params: RequestParams = {}) => {
      return this.request<
        {
          data: ITicket
        },
        GenericErrorModel
      >({
        path: `/ticket/tickets/${id}`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    update: (id: RecordId, record: ITicket, params: RequestParams = {}) =>
      this.request<ITicket, GenericErrorModel>({
        path: `/ticket/tickets/${id}`,
        method: 'PATCH',
        body: record,
        ...params,
      }),
    create: (record: ITicket, params: RequestParams = {}) =>
      this.request<ITicket, GenericErrorModel>({
        path: `/ticket/tickets`,
        method: 'POST',
        body: record,
        ...params,
      }),
    opeprate: (
      id: RecordId,
      type: OperationType,
      body: string,
      parameters: {},
      content: [],
      attachments: [],
      params: RequestParams = {},
    ) =>
      this.request<ITicket, GenericErrorModel>({
        path: `/ticket/tickets/${id}/operations`,
        method: 'POST',
        body: {
          type,
          body,
          parameters,
          content,
          attachments,
        },
        ...params,
      }),
      actions: (actionName: "request-export", parameters: {}, records: any = null, params: RequestParams = {}) => {
        return this.request<
          GenericErrorModel
        >({
          path: `/ticket/tickets/actions`,
          method: 'POST',
          body: {
            action: actionName, 
            parameters,
            records
          },
          ...params,
        })
      },
    operations: {
      index: (id: RecordId, params: RequestParams = {}) => {
        return this.request<
          {
            data: []
          },
          GenericErrorModel
        >({
          path: `/ticket/tickets/${id}/operations`,
          method: 'GET',
          ...params,
        })
      },
    },
    templates: {
      index: (params: RequestParams = {}) => {
        return this.request<
          {
            data: ISchemaTemplate[]
          },
          GenericErrorModel
        >({
          path: `/ticket/schema-templates`,
          method: 'GET',
          ...params,
        })
      },
      show: (id: RecordId, params: RequestParams = {}) => {
        return this.request<
          {
            data: ISchemaTemplate
          },
          GenericErrorModel
        >({
          path: `/ticket/schema-templates/${id}`,
          method: 'GET',
          ...params,
        })
      },
    },
  }
  repairOrders = {
    tickets: {
      index: (
        orderId: RecordId,
        query?: {
          /**
           * The numbers of items to return.
           * @min 1
           * @default 20
           */
          per_page?: number

          /**
           * @default 1
           */
          page?: number

          sorter?: any
          filters?: any
        },
        params: RequestParams = {},
      ) => {
        return this.request<
          {
            data: ITicket[]
            meta: PaginationMeta
          },
          GenericErrorModel
        >({
          path: `/repair-orders/${orderId}/tickets`,
          method: 'GET',
          query: parseQuery(query),
          ...params,
        })
      },
    },
    items: {
      tickets: {
        attach: (
          orderId: RecordId,
          itemId: Record,
          ticketId: RecordId,
          params: RequestParams = {},
        ) =>
          this.request<{}, GenericErrorModel>({
            path: `/repair-orders/${orderId}/items/${itemId}/tickets`,
            method: 'POST',
            body: {
              repair_order_id: orderId,
              repair_order_item_id: itemId,
              ticket_id: ticketId,
            },
            ...params,
          }),
      },
    },
    comments: {
      index: (
        id: RecordId,
        query?: {
          /**
           * The numbers of items to return.
           * @min 1
           * @default 20
           */
          per_page?: number

          /**
           * @default 1
           */
          page?: number

          sorter?: any
          filters?: any
        },
        params: RequestParams = {},
      ) => {
        return this.request<
          {
            data: IComment[]
            meta: PaginationMeta
          },
          GenericErrorModel
        >({
          path: `/repair-orders/${id}/comments`,
          method: 'GET',
          query: parseQuery(query),
          ...params,
        })
      },
      create: (
        id: RecordId,
        record: { comment: string; attachments?: RecordId[] },
        params: RequestParams = {},
      ) =>
        this.request<
          {
            data: IComment
          },
          GenericErrorModel
        >({
          path: `/repair-orders/${id}/comments`,
          method: 'POST',
          body: record,
          ...params,
        }),
    },
    index: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) => {
      return this.request<
        {
          data: IRepairOrder[]
          meta: PaginationMeta
        },
        GenericErrorModel
      >({
        path: `/repair-orders`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    show: (id: RecordId, query = {}, params: RequestParams = {}) => {
      return this.request<
        {
          data: IRepairOrder
        },
        GenericErrorModel
      >({
        path: `/repair-orders/${id}`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },
    update: (id: RecordId, record: IRepairOrder, params: RequestParams = {}) =>
      this.request<
        {
          data: IRepairOrder
        },
        GenericErrorModel
      >({
        path: `/repair-orders/${id}`,
        method: 'PATCH',
        body: record,
        ...params,
      }),
    create: (record: IRepairOrder, params: RequestParams = {}) =>
      this.request<
        {
          data: IRepairOrder
        },
        GenericErrorModel
      >({
        path: `/repair-orders`,
        method: 'POST',
        body: record,
        ...params,
      }),
    actions: (
      id: RecordId,
      action: 'cancel' | 'revert-status' | 'complete' | 'request-return',
      parameters: {},
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: IRepairOrder
        },
        GenericErrorModel
      >({
        path: `/repair-orders/${id}/actions`,
        method: 'POST',
        body: {
          action,
          parameters,
        },
        ...params,
      }),

    stats: (query = {}, params: RequestParams = {}) => {
      return this.request<{}, GenericErrorModel>({
        path: `/repair-orders/stats`,
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
    },

    export: (
      query?: {
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        per_page?: number

        /**
         * @default 1
         */
        page?: number

        sorter?: any
        filters?: any
      },
      params: RequestParams = {},
    ) =>
      this.request<GenericErrorModel>({
        path: `/repair-orders/export`,
        format: 'blob',
        method: 'GET',
        query: parseQuery(query),
        ...params,
      })
        .then(res => res.response.data)
        .then(blob =>
          downloadjs(
            blob,
            `${dayjs().format('YYYYMMDDHHmmss')}-repairOrders.xls`,
            'application/vnd.ms-excel',
          ),
        ),
  }
  profiles = {
    /**
     * @description Get a profile of a user of the system. Auth is optional
     *
     * @tags Profile
     * @name GetProfileByUsername
     * @summary Get a profile
     * @request GET:/profiles/{username}
     */
    getProfileByUsername: (username: string, params: RequestParams = {}) =>
      this.request<
        {
          profile: Profile
        },
        GenericErrorModel
      >({
        path: `/profiles/${username}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Follow a user by username
     *
     * @tags Profile
     * @name FollowUserByUsername
     * @summary Follow a user
     * @request POST:/profiles/{username}/follow
     * @secure
     */
    followUserByUsername: (username: string, params: RequestParams = {}) =>
      this.request<
        {
          profile: Profile
        },
        GenericErrorModel
      >({
        path: `/profiles/${username}/follow`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Unfollow a user by username
     *
     * @tags Profile
     * @name UnfollowUserByUsername
     * @summary Unfollow a user
     * @request DELETE:/profiles/{username}/follow
     * @secure
     */
    unfollowUserByUsername: (username: string, params: RequestParams = {}) =>
      this.request<
        {
          profile: Profile
        },
        GenericErrorModel
      >({
        path: `/profiles/${username}/follow`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  articles = {
    /**
     * @description Get most recent articles from users you follow. Use query parameters to limit. Auth is required
     *
     * @tags Articles
     * @name GetArticlesFeed
     * @summary Get recent articles from users you follow
     * @request GET:/articles/feed
     * @secure
     */
    getArticlesFeed: (
      query?: {
        /**
         * The number of items to skip before starting to collect the result set.
         * @min 0
         */
        offset?: number
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        limit?: number
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          articles: Article[]
          articlesCount: number
        },
        GenericErrorModel
      >({
        path: `/articles/feed`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Get most recent articles globally. Use query parameters to filter results. Auth is optional
     *
     * @tags Articles
     * @name GetArticles
     * @summary Get recent articles globally
     * @request GET:/articles
     */
    getArticles: (
      query?: {
        /** Filter by tag */
        tag?: string
        /** Filter by author (username) */
        author?: string
        /** Filter by favorites of a user (username) */
        favorited?: string
        /**
         * The number of items to skip before starting to collect the result set.
         * @min 0
         */
        offset?: number
        /**
         * The numbers of items to return.
         * @min 1
         * @default 20
         */
        limit?: number
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          articles: Article[]
          articlesCount: number
        },
        GenericErrorModel
      >({
        path: `/articles`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Create an article. Auth is required
     *
     * @tags Articles
     * @name CreateArticle
     * @summary Create an article
     * @request POST:/articles
     * @secure
     */
    createArticle: (
      data: {
        article: NewArticle
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          article: Article
        },
        GenericErrorModel
      >({
        path: `/articles`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Get an article. Auth not required
     *
     * @tags Articles
     * @name GetArticle
     * @summary Get an article
     * @request GET:/articles/{slug}
     */
    getArticle: (slug: string, params: RequestParams = {}) =>
      this.request<
        {
          article: Article
        },
        GenericErrorModel
      >({
        path: `/articles/${slug}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Update an article. Auth is required
     *
     * @tags Articles
     * @name UpdateArticle
     * @summary Update an article
     * @request PUT:/articles/{slug}
     * @secure
     */
    updateArticle: (
      slug: string,
      data: {
        article: UpdateArticle
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          article: Article
        },
        GenericErrorModel
      >({
        path: `/articles/${slug}`,
        method: 'PUT',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Delete an article. Auth is required
     *
     * @tags Articles
     * @name DeleteArticle
     * @summary Delete an article
     * @request DELETE:/articles/{slug}
     * @secure
     */
    deleteArticle: (slug: string, params: RequestParams = {}) =>
      this.request<any, GenericErrorModel>({
        path: `/articles/${slug}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Get the comments for an article. Auth is optional
     *
     * @tags Comments
     * @name GetArticleComments
     * @summary Get comments for an article
     * @request GET:/articles/{slug}/comments
     */
    getArticleComments: (slug: string, params: RequestParams = {}) =>
      this.request<
        {
          comments: Comment[]
        },
        GenericErrorModel
      >({
        path: `/articles/${slug}/comments`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Create a comment for an article. Auth is required
     *
     * @tags Comments
     * @name CreateArticleComment
     * @summary Create a comment for an article
     * @request POST:/articles/{slug}/comments
     * @secure
     */
    createArticleComment: (
      slug: string,
      data: {
        comment: NewComment
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          comment: Comment
        },
        GenericErrorModel
      >({
        path: `/articles/${slug}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Delete a comment for an article. Auth is required
     *
     * @tags Comments
     * @name DeleteArticleComment
     * @summary Delete a comment for an article
     * @request DELETE:/articles/{slug}/comments/{id}
     * @secure
     */
    deleteArticleComment: (slug: string, id: number, params: RequestParams = {}) =>
      this.request<any, GenericErrorModel>({
        path: `/articles/${slug}/comments/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Favorite an article. Auth is required
     *
     * @tags Favorites
     * @name CreateArticleFavorite
     * @summary Favorite an article
     * @request POST:/articles/{slug}/favorite
     * @secure
     */
    createArticleFavorite: (slug: string, params: RequestParams = {}) =>
      this.request<
        {
          article: Article
        },
        GenericErrorModel
      >({
        path: `/articles/${slug}/favorite`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Unfavorite an article. Auth is required
     *
     * @tags Favorites
     * @name DeleteArticleFavorite
     * @summary Unfavorite an article
     * @request DELETE:/articles/{slug}/favorite
     * @secure
     */
    deleteArticleFavorite: (slug: string, params: RequestParams = {}) =>
      this.request<
        {
          article: Article
        },
        GenericErrorModel
      >({
        path: `/articles/${slug}/favorite`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  tags = {
    /**
     * @description Get tags. Auth not required
     *
     * @tags Tags
     * @name GetTags
     * @summary Get tags
     * @request GET:/tags
     */
    getTags: (params: RequestParams = {}) =>
      this.request<
        {
          tags: string[]
        },
        GenericErrorModel
      >({
        path: `/tags`,
        method: 'GET',
        ...params,
      }),
  }
}
